<template>
  <div>
    <EditForm
      ref="editForm"
      :disabled="disabled"
      :opt-type="pageType"
      :amzFlipOrderCode="amzFlipOrderCode"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-awsBiz-skuOrderMonitor-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    amzFlipOrderCode() {
      return this.params.code
    },
  },
}
</script>
